import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommCalendarIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M6 1.25C6.41421 1.25 6.75 1.58579 6.75 2V4C6.75 4.41421 6.41421 4.75 6 4.75C5.58579 4.75 5.25 4.41421 5.25 4V2C5.25 1.58579 5.58579 1.25 6 1.25ZM18 1.25C18.4142 1.25 18.75 1.58579 18.75 2V4C18.75 4.41421 18.4142 4.75 18 4.75C17.5858 4.75 17.25 4.41421 17.25 4V2C17.25 1.58579 17.5858 1.25 18 1.25Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M10.9892 2.25H13.0108C14.9745 2.24998 16.5307 2.24997 17.7487 2.427C19.0072 2.60993 20.0129 2.99506 20.7985 3.84436C21.5764 4.68534 21.9222 5.74792 22.0878 7.07951C22.25 8.38431 22.25 10.0565 22.25 12.1901V12.8099C22.25 14.9435 22.25 16.6157 22.0878 17.9205C21.9222 19.2521 21.5764 20.3147 20.7985 21.1556C20.0129 22.0049 19.0072 22.3901 17.7487 22.573C16.5307 22.75 14.9745 22.75 13.0108 22.75H10.9892C9.02555 22.75 7.46932 22.75 6.25129 22.573C4.99276 22.3901 3.98714 22.0049 3.20154 21.1556C2.42363 20.3147 2.07785 19.2521 1.91225 17.9205C1.74998 16.6157 1.74999 14.9435 1.75 12.81V12.19C1.74999 10.0565 1.74998 8.3843 1.91225 7.07951C2.07785 5.74792 2.42363 4.68534 3.20154 3.84436C3.98714 2.99506 4.99276 2.60993 6.25129 2.427C7.46932 2.24997 9.02555 2.24998 10.9892 2.25ZM6.46704 3.91141C5.39728 4.06689 4.76921 4.35858 4.30269 4.86292C3.82849 5.37558 3.54821 6.07915 3.40078 7.26463C3.25137 8.46607 3.25 10.0449 3.25 12.2432V12.7568C3.25 14.9551 3.25137 16.5339 3.40078 17.7354C3.54821 18.9208 3.82849 19.6244 4.30269 20.1371C4.76921 20.6414 5.39728 20.9331 6.46704 21.0886C7.56476 21.2481 9.01188 21.25 11.05 21.25H12.95C14.9881 21.25 16.4352 21.2481 17.533 21.0886C18.6027 20.9331 19.2308 20.6414 19.6973 20.1371C20.1715 19.6244 20.4518 18.9208 20.5992 17.7354C20.7486 16.5339 20.75 14.9551 20.75 12.7568V12.2432C20.75 10.0449 20.7486 8.46607 20.5992 7.26463C20.4518 6.07915 20.1715 5.37558 19.6973 4.86292C19.2308 4.35858 18.6027 4.06689 17.533 3.91141C16.4352 3.75186 14.9881 3.75 12.95 3.75H11.05C9.01188 3.75 7.56476 3.75186 6.46704 3.91141Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M2.25 8C2.25 7.58579 2.58579 7.25 3 7.25H21C21.4142 7.25 21.75 7.58579 21.75 8C21.75 8.41421 21.4142 8.75 21 8.75H3C2.58579 8.75 2.25 8.41421 2.25 8Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
